import React from 'react'

const PlacementNoData = () => {
  return (
    <svg
      style={{ width: '260px' }}
      width="339"
      height="282"
      viewBox="0 0 339 282"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1769_21252)">
        <path
          d="M148.455 281.068C230.444 281.068 296.909 277.187 296.909 272.4C296.909 267.614 230.444 263.733 148.455 263.733C66.4654 263.733 0 267.614 0 272.4C0 277.187 66.4654 281.068 148.455 281.068Z"
          fill="#F5F5F5"
        />
        <path
          d="M249.668 75.1499C249.538 77.4469 249.27 79.5525 248.971 81.7346C248.673 83.9015 248.267 86.053 247.8 88.1969C246.896 92.4846 245.648 96.7417 243.933 100.884L243.244 102.431L243.068 102.813L242.984 103.005C242.953 103.066 242.93 103.12 242.869 103.25C242.655 103.679 242.379 104.138 241.988 104.574C241.598 105.011 241.1 105.44 240.526 105.731C239.959 106.029 239.332 106.221 238.78 106.282C237.639 106.42 236.751 106.213 236.001 105.991C234.523 105.509 233.459 104.842 232.448 104.161C231.461 103.464 230.572 102.729 229.73 101.979C226.407 98.9162 223.635 95.6391 221.078 92.0711L223.62 89.9273C225.113 91.3437 226.667 92.7679 228.222 94.1308C229.768 95.5013 231.376 96.7953 232.984 97.9591C233.788 98.541 234.6 99.0769 235.404 99.521C236.185 99.9651 237.004 100.333 237.563 100.44C237.831 100.493 238.015 100.463 237.93 100.44C237.854 100.402 237.517 100.562 237.44 100.654C237.394 100.693 237.394 100.692 237.41 100.647L237.655 100.003L238.191 98.6099C239.515 94.8352 240.518 90.8767 241.292 86.8493C241.69 84.8432 241.981 82.7989 242.279 80.7699C242.57 78.7562 242.8 76.6506 242.976 74.7135L249.676 75.1346L249.668 75.1499Z"
          fill="#FFC3BD"
        />
        <path
          d="M245.036 66.7276C242.18 67.455 240.189 79.2003 240.189 79.2003L248.053 84.5446C248.053 84.5446 255.595 72.6998 253.397 69.5606C251.108 66.2912 249.201 65.671 245.036 66.7276Z"
          fill="#407BFF"
        />
        <path
          d="M245.036 66.7276C242.18 67.455 240.189 79.2003 240.189 79.2003L248.053 84.5446C248.053 84.5446 255.595 72.6998 253.397 69.5606C251.108 66.2912 249.201 65.671 245.036 66.7276Z"
          fill="#407BFF"
        />
        <path
          opacity="0.4"
          d="M245.036 66.7276C242.18 67.455 240.189 79.2003 240.189 79.2003L248.053 84.5446C248.053 84.5446 255.595 72.6998 253.397 69.5606C251.108 66.2912 249.201 65.671 245.036 66.7276Z"
          fill="black"
        />
        <path
          opacity="0.3"
          d="M245.287 69.3539L243.098 81.1834L247.516 84.1848L245.287 69.3539Z"
          fill="black"
        />
        <path
          d="M223.75 89.4372L220.006 83.5262L217.885 90.2411C217.885 90.2411 220.955 93.4569 223.727 92.6913L223.75 89.4372Z"
          fill="#FFC3BD"
        />
        <path
          d="M214.531 81.5815L213.061 87.2934L217.892 90.2489L220.013 83.534L214.531 81.5815Z"
          fill="#FFC3BD"
        />
        <path
          d="M260.471 264.369H253.549L253.082 248.336H260.011L260.471 264.369Z"
          fill="#FFC3BD"
        />
        <path
          d="M321.563 232.211L316.287 236.698L304.213 225.917L309.488 221.43L321.563 232.211Z"
          fill="#FFC3BD"
        />
        <path
          d="M314.842 236.154L319.956 230.297C320.14 230.082 320.439 230.036 320.676 230.189L325.89 233.574C326.434 233.926 326.526 234.737 326.089 235.22C324.267 237.234 323.287 238.114 321.036 240.687C319.65 242.272 317.789 244.729 315.883 246.919C314.015 249.063 311.702 247.333 312.307 246.253C314.995 241.399 314.351 239.691 314.397 237.31C314.405 236.881 314.566 236.468 314.842 236.162V236.154Z"
          fill="#263238"
        />
        <path
          d="M253.312 263.572H261.091C261.375 263.572 261.604 263.771 261.643 264.047L262.531 270.203C262.623 270.838 262.071 271.443 261.421 271.436C258.71 271.39 257.401 271.229 253.978 271.229C251.873 271.229 247.524 271.451 244.614 271.451C241.705 271.451 241.552 268.58 242.761 268.319C248.19 267.156 250.326 265.54 252.148 264.009C252.478 263.733 252.891 263.58 253.305 263.58L253.312 263.572Z"
          fill="#263238"
        />
        <path
          opacity="0.2"
          d="M253.09 248.343L253.32 256.605H260.249L260.011 248.343H253.09Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M309.496 221.438L304.213 225.917L310.438 231.476L315.721 226.989L309.496 221.438Z"
          fill="black"
        />
        <path
          d="M245.035 66.7276C245.035 66.7276 241.735 67.8914 248.343 108.518H276.458C275.983 97.0709 275.975 90.0191 281.442 66.5285C281.442 66.5285 275.554 65.2498 269.506 64.9589C264.774 64.7292 260.9 64.5761 256.734 64.9589C251.252 65.4566 245.035 66.7352 245.035 66.7352V66.7276Z"
          fill="#407BFF"
        />
        <path
          opacity="0.4"
          d="M245.035 66.7276C245.035 66.7276 241.735 67.8914 248.343 108.518H276.458C275.983 97.0709 275.975 90.0191 281.442 66.5285C281.442 66.5285 275.554 65.2498 269.506 64.9589C264.774 64.7292 260.9 64.5761 256.734 64.9589C251.252 65.4566 245.035 66.7352 245.035 66.7352V66.7276Z"
          fill="black"
        />
        <path
          d="M269.506 64.9513C264.774 64.7292 260.9 64.5761 256.734 64.9589C256.045 65.0202 255.341 65.0968 254.644 65.181C254.177 65.9849 253.825 67.0645 254.261 68.1671C255.157 70.3952 258.388 70.6555 260.746 70.6555C269.452 70.6555 270.922 65.5715 270.983 65.3571L271.068 65.0508C270.547 65.0125 270.026 64.9743 269.506 64.9513Z"
          fill="white"
        />
        <path
          d="M268.234 50.5797C267.43 54.6913 266.626 62.2178 269.498 64.9589C269.498 64.9589 268.372 69.1241 260.738 69.1241C252.347 69.1241 256.726 64.9589 256.726 64.9589C261.305 63.864 261.19 60.4644 260.394 57.2716L268.234 50.5797Z"
          fill="#FFC3BD"
        />
        <path
          opacity="0.2"
          d="M265.042 53.3055L260.402 57.264C260.594 58.022 260.739 58.7877 260.793 59.5304C262.546 59.2777 264.95 57.3559 265.134 55.526C265.226 54.6148 265.188 53.7343 265.042 53.3055Z"
          fill="black"
        />
        <path
          d="M263.465 28.2376C262.753 25.8335 262.141 22.0281 266.436 20.3513C264.759 18.2993 264.353 14.4404 266.413 12.151C268.473 9.8617 271.619 10.7039 271.619 10.7039C271.619 10.7039 272.538 5.10692 279.345 6.08697C286.152 7.06702 283.12 11.5691 283.12 11.5691C283.12 11.5691 292.407 9.73153 293.027 18.4831C293.648 27.2346 288.319 26.155 288.319 26.155C288.319 26.155 292.461 29.6312 290.171 33.4518C287.882 37.2725 282.568 35.9555 282.568 35.9555C282.568 35.9555 280.072 42.7087 274.192 38.8651C268.312 35.0214 263.473 28.2453 263.473 28.2453L263.465 28.2376Z"
          fill="#263238"
        />
        <path
          d="M249.676 33.314C247.371 36.2771 248.39 39.6461 250.419 40.94C255.357 44.0946 262.501 30.8715 260.64 29.2866C258.78 27.7017 251.973 30.3509 249.668 33.314H249.676Z"
          fill="#263238"
        />
        <path
          d="M270.418 26.2546C267.171 24.9453 263.879 26.3159 262.853 28.2913C260.349 33.1073 271.72 41.7823 275.012 35.7642C276.964 32.1885 273.771 27.6098 270.418 26.2546Z"
          fill="#407BFF"
        />
        <path
          d="M269.032 40.9631C269.269 47.8311 269.514 50.7329 266.398 54.5689C261.72 60.3344 253.229 59.1246 250.947 52.4633C248.895 46.4682 248.857 36.2466 255.273 32.8929C261.597 29.5853 268.787 34.1027 269.024 40.9707L269.032 40.9631Z"
          fill="#FFC3BD"
        />
        <path
          d="M268.005 44.5846C264.965 43.4437 264.169 39.8681 264.674 38.4899C263.158 38.4286 259.789 37.8774 258.534 35.9785C256.145 37.4792 251.099 39.0335 250.548 36.4992C249.997 33.9572 257.623 27.3877 263.373 26.8901C270.218 26.2928 276.971 33.023 275.225 39.4546C273.479 45.8862 267.997 44.5846 267.997 44.5846H268.005Z"
          fill="#263238"
        />
        <path
          d="M248.343 108.518C248.343 108.518 242.883 161.854 243.335 182.963C243.81 204.922 251.857 255.012 251.857 255.012H261.221C261.221 255.012 259.736 206.209 260.57 184.64C261.474 161.126 268.939 108.518 268.939 108.518H248.35H248.343Z"
          fill="#263238"
        />
        <path
          d="M262.026 255.341H251.038L250.234 251.835L262.539 251.406L262.026 255.341Z"
          fill="#407BFF"
        />
        <path
          opacity="0.2"
          d="M260.472 121.787C253.566 135.683 259.086 161.027 261.528 170.452C262.784 156.287 264.89 138.983 266.536 126.266C265.487 119.076 263.657 115.378 260.472 121.787Z"
          fill="black"
        />
        <path
          d="M255.77 108.518C255.77 108.518 262.14 163.967 266.948 181.761C272.66 202.893 308.133 231.338 308.133 231.338L315.331 225.228C315.331 225.228 289.62 194.333 285.255 183.201C275.937 159.442 283.915 124.03 276.465 108.518H255.77Z"
          fill="#263238"
        />
        <path
          d="M316.471 224.899L307.551 232.479L304.213 230.48L314.312 221.086L316.471 224.899Z"
          fill="#407BFF"
        />
        <path
          d="M258.855 43.8649C258.909 44.4239 258.656 44.8986 258.296 44.9369C257.937 44.9751 257.592 44.5464 257.538 43.9951C257.485 43.4438 257.738 42.9614 258.097 42.9232C258.457 42.8849 258.802 43.3136 258.855 43.8649Z"
          fill="#263238"
        />
        <path
          d="M252.57 44.4698C252.624 45.0287 252.371 45.5034 252.011 45.5417C251.651 45.58 251.307 45.1512 251.253 44.5999C251.2 44.0487 251.452 43.5663 251.812 43.528C252.172 43.4897 252.517 43.9185 252.57 44.4698Z"
          fill="#263238"
        />
        <path
          d="M251.98 43.5356L250.609 43.2753C250.609 43.2753 251.398 44.2553 251.98 43.5356Z"
          fill="#263238"
        />
        <path
          d="M254.322 45.266C254.322 45.266 253.61 47.7467 252.684 49.0024C253.48 49.615 254.697 49.1862 254.697 49.1862L254.322 45.266Z"
          fill="#ED847E"
        />
        <path
          d="M259.491 48.9565C259.774 48.8799 260.081 48.8187 260.418 48.7881C260.509 48.7804 260.586 48.8493 260.594 48.9335C260.601 49.0254 260.54 49.102 260.448 49.1096C258.013 49.3393 257.033 51.154 257.026 51.1769C256.987 51.2612 256.888 51.2918 256.804 51.2458C256.727 51.2076 256.689 51.108 256.735 51.0238C256.773 50.9549 257.562 49.4925 259.499 48.9565H259.491Z"
          fill="#263238"
        />
        <path
          d="M270.647 45.7407C270.478 47.1572 269.682 48.3593 268.748 49.0713C267.347 50.1433 265.999 49.0484 265.839 47.3869C265.693 45.8938 266.252 43.5356 267.921 43.1145C269.56 42.701 270.831 44.1175 270.647 45.7331V45.7407Z"
          fill="#FFC3BD"
        />
        <path
          d="M259.53 39.9217C259.445 39.9447 259.354 39.937 259.269 39.8834C258.014 39.1331 256.926 39.6461 256.911 39.6537C256.75 39.7303 256.551 39.6614 256.475 39.5006C256.398 39.3398 256.467 39.1407 256.628 39.0642C256.681 39.0335 258.052 38.3904 259.606 39.3245C259.759 39.4164 259.813 39.6154 259.721 39.7762C259.675 39.8528 259.606 39.8987 259.53 39.9217Z"
          fill="#263238"
        />
        <path
          d="M249.499 41.8359C249.422 41.8589 249.33 41.8512 249.254 41.8129C249.093 41.7287 249.032 41.5296 249.116 41.3689C249.973 39.7686 251.482 39.6231 251.543 39.6155C251.727 39.6002 251.88 39.7303 251.895 39.9141C251.911 40.0978 251.78 40.251 251.597 40.2663C251.535 40.2663 250.372 40.4041 249.69 41.6751C249.644 41.7593 249.575 41.8129 249.491 41.8359H249.499Z"
          fill="#263238"
        />
        <path
          d="M284.315 73.9937C285.907 77.868 287.209 81.6963 288.35 85.6778C289.468 89.6516 290.44 93.6866 290.892 97.959C291.022 99.0157 291.06 100.118 291.114 101.213V101.313V101.481V101.833C291.091 102.055 291.068 102.277 291.037 102.484C290.976 102.898 290.884 103.273 290.777 103.617C290.57 104.314 290.302 104.904 290.027 105.463C288.893 107.637 287.546 109.291 286.145 110.891C283.304 114.03 280.287 116.748 276.98 119.252L274.736 116.794C277.286 113.824 279.866 110.761 282.041 107.637C283.113 106.09 284.139 104.467 284.721 103.012C284.858 102.653 284.966 102.316 285.019 102.04C285.042 101.902 285.065 101.787 285.065 101.703C285.065 101.657 285.065 101.634 285.065 101.604C285.065 101.588 285.065 101.588 285.057 101.581V101.481C284.943 100.57 284.874 99.6741 284.705 98.7477C284.131 95.0572 283.082 91.2978 281.957 87.5766C280.785 83.8708 279.476 80.1114 278.098 76.5281L284.315 73.9861V73.9937Z"
          fill="#FFC3BD"
        />
        <path
          d="M281.442 66.5286C284.26 67.3861 287.644 77.0871 287.644 77.0871L276.718 84.9045C276.718 84.9045 272.729 76.8038 273.916 73.1669C275.149 69.3769 278.234 65.5562 281.45 66.5363L281.442 66.5286Z"
          fill="#407BFF"
        />
        <path
          opacity="0.4"
          d="M281.442 66.5286C284.26 67.3861 287.644 77.0871 287.644 77.0871L276.718 84.9045C276.718 84.9045 272.729 76.8038 273.916 73.1669C275.149 69.3769 278.234 65.5562 281.45 66.5363L281.442 66.5286Z"
          fill="black"
        />
        <path
          d="M312.949 239.5C312.681 239.5 312.436 239.377 312.214 239.125C312.031 238.91 312.038 238.711 312.084 238.573C312.337 237.731 314.749 237.034 315.017 236.958C315.078 236.942 315.147 236.958 315.185 237.011C315.223 237.065 315.231 237.134 315.201 237.187C314.772 237.999 313.922 239.385 313.041 239.484C313.003 239.484 312.972 239.484 312.942 239.484L312.949 239.5ZM314.726 237.394C313.769 237.7 312.536 238.229 312.398 238.673C312.383 238.726 312.375 238.811 312.467 238.91C312.636 239.109 312.819 239.186 313.018 239.171C313.493 239.117 314.121 238.458 314.726 237.394Z"
          fill="#407BFF"
        />
        <path
          d="M313.968 237.417C313.172 237.417 312.276 237.256 311.962 236.858C311.87 236.736 311.747 236.483 311.977 236.139C312.123 235.924 312.337 235.794 312.597 235.763C313.593 235.633 315.101 236.942 315.162 236.996C315.208 237.034 315.224 237.096 315.216 237.149C315.208 237.203 315.162 237.256 315.109 237.272C314.848 237.364 314.42 237.417 313.96 237.417H313.968ZM312.75 236.085C312.75 236.085 312.682 236.085 312.643 236.085C312.475 236.108 312.345 236.184 312.253 236.322C312.138 236.498 312.176 236.59 312.222 236.652C312.521 237.034 313.876 237.18 314.711 237.034C314.213 236.652 313.348 236.077 312.75 236.077V236.085Z"
          fill="#407BFF"
        />
        <path
          d="M250.709 264.782C250.02 264.782 249.384 264.675 249.032 264.353C248.81 264.147 248.703 263.879 248.734 263.557C248.749 263.358 248.849 263.212 249.009 263.121C249.859 262.653 252.616 264.062 252.93 264.231C252.991 264.261 253.029 264.33 253.014 264.399C253.006 264.468 252.952 264.522 252.884 264.537C252.294 264.652 251.467 264.782 250.701 264.782H250.709ZM249.476 263.35C249.346 263.35 249.247 263.366 249.17 263.411C249.101 263.45 249.071 263.503 249.063 263.588C249.04 263.81 249.109 263.978 249.254 264.116C249.675 264.491 250.816 264.56 252.348 264.307C251.398 263.848 250.135 263.358 249.476 263.358V263.35Z"
          fill="#407BFF"
        />
        <path
          d="M252.861 264.537C252.861 264.537 252.815 264.537 252.792 264.522C251.965 264.147 250.334 262.654 250.464 261.873C250.495 261.689 250.625 261.459 251.077 261.413C251.414 261.383 251.72 261.474 251.988 261.696C252.861 262.424 253.022 264.284 253.022 264.361C253.022 264.422 252.999 264.476 252.953 264.506C252.922 264.529 252.892 264.537 252.861 264.537ZM251.207 261.727C251.207 261.727 251.138 261.727 251.108 261.727C250.809 261.758 250.786 261.88 250.778 261.919C250.702 262.393 251.812 263.565 252.647 264.07C252.57 263.526 252.333 262.409 251.766 261.934C251.598 261.788 251.406 261.719 251.199 261.719L251.207 261.727Z"
          fill="#407BFF"
        />
        <path
          d="M276.879 106.864L277.598 109.383C277.698 109.582 277.468 109.781 277.139 109.781H248.197C247.944 109.781 247.73 109.658 247.714 109.498L247.462 106.979C247.446 106.802 247.661 106.657 247.944 106.657H276.419C276.626 106.657 276.817 106.741 276.879 106.871V106.864Z"
          fill="#407BFF"
        />
        <path
          opacity="0.3"
          d="M276.879 106.864L277.598 109.383C277.698 109.582 277.468 109.781 277.139 109.781H248.197C247.944 109.781 247.73 109.658 247.714 109.498L247.462 106.979C247.446 106.802 247.661 106.657 247.944 106.657H276.419C276.626 106.657 276.817 106.741 276.879 106.871V106.864Z"
          fill="white"
        />
        <path
          d="M273.059 110.049H273.825C273.978 110.049 274.093 109.972 274.085 109.873L273.725 106.603C273.718 106.512 273.58 106.427 273.427 106.427H272.661C272.508 106.427 272.393 106.504 272.401 106.603L272.761 109.873C272.768 109.965 272.906 110.049 273.059 110.049Z"
          fill="#263238"
        />
        <path
          d="M250.34 110.049H251.106C251.259 110.049 251.374 109.972 251.366 109.873L251.007 106.603C250.999 106.512 250.861 106.427 250.708 106.427H249.942C249.789 106.427 249.674 106.504 249.682 106.603L250.042 109.873C250.05 109.965 250.187 110.049 250.34 110.049Z"
          fill="#263238"
        />
        <path
          d="M261.704 110.049H262.469C262.623 110.049 262.737 109.972 262.73 109.873L262.37 106.603C262.362 106.512 262.224 106.427 262.071 106.427H261.306C261.152 106.427 261.038 106.504 261.045 106.603L261.405 109.873C261.413 109.965 261.551 110.049 261.704 110.049Z"
          fill="#263238"
        />
        <path
          d="M258.265 42.9384L256.895 42.6781C256.895 42.6781 257.683 43.6582 258.265 42.9384Z"
          fill="#263238"
        />
        <path
          opacity="0.2"
          d="M224.14 140.438C187.924 154.511 147.144 136.564 133.064 100.34C118.983 64.1167 136.946 23.3374 173.162 9.26451C209.385 -4.81606 250.165 13.1311 264.245 49.3624C278.326 85.586 260.363 126.365 224.14 140.438Z"
          fill="#407BFF"
        />
        <path
          opacity="0.1"
          d="M211.408 5.64289L156.219 130.99C155.369 130.347 154.527 129.681 153.7 128.999C148.44 124.65 143.785 119.497 139.926 113.625L187.588 5.35959C195.605 4.06562 203.66 4.21109 211.408 5.65054V5.64289Z"
          fill="white"
        />
        <path
          opacity="0.1"
          d="M250.639 27.3954L198.75 145.231C187.878 145.247 177.243 142.727 167.664 138.019L224.323 9.34106C234.269 13.2306 243.304 19.3713 250.639 27.3954Z"
          fill="white"
        />
        <path
          d="M140.736 27.449C166.915 -4.54044 214.072 -9.24927 246.061 16.9288C278.051 43.1069 282.76 90.2642 256.582 122.254C230.396 154.251 183.239 158.96 151.249 132.782C119.26 106.603 114.551 59.4462 140.736 27.449ZM251.85 118.379C275.884 89.0085 271.566 45.7025 242.187 21.6606C212.808 -2.38126 169.51 1.9524 145.468 31.3233C121.426 60.7018 125.745 104.008 155.123 128.05C184.502 152.092 227.8 147.758 251.85 118.379Z"
          fill="#407BFF"
        />
        <path
          d="M258.451 118.119C265.824 122.522 272.837 127.361 279.728 132.353C286.619 137.345 293.334 142.551 299.95 147.88C306.565 153.209 313.043 158.707 319.298 164.472C322.43 167.351 325.5 170.307 328.509 173.339C331.51 176.378 334.466 179.472 337.238 182.787C338.769 184.609 338.524 187.335 336.702 188.859C335.308 190.03 333.379 190.16 331.87 189.341C328.073 187.274 324.459 184.992 320.883 182.649C317.315 180.299 313.808 177.879 310.37 175.375C303.479 170.383 296.81 165.123 290.279 159.695C283.748 154.266 277.317 148.715 271.061 142.949C264.806 137.184 258.673 131.265 252.9 124.91C251.253 123.096 251.384 120.293 253.198 118.64C254.676 117.292 256.82 117.139 258.458 118.111L258.451 118.119Z"
          fill="#407BFF"
        />
        <path
          d="M275.463 116.036L268.066 117.162L273.365 121.802C273.365 121.802 277.545 120.286 277.959 117.438L275.47 116.036H275.463Z"
          fill="#FFC3BD"
        />
        <path
          d="M264.078 121.396L268.726 125.041L274.399 121.335L268.075 117.154L264.078 121.396Z"
          fill="#FFC3BD"
        />
        <path
          d="M192.741 129.459C194.065 125.73 197.786 123.081 201.707 123.081H262.998C267.646 123.081 270.976 126.764 270.44 131.296L254.614 264.177C254.07 268.718 249.867 272.393 245.212 272.393H50.7098C46.0622 272.393 42.7316 268.71 43.2675 264.177L56.5595 152.559C57.1031 148.018 61.3066 144.343 65.9618 144.343H171.8C180.965 144.343 189.647 138.164 192.741 129.451V129.459Z"
          fill="#407BFF"
        />
        <path
          d="M46.7969 266.283H250.012L261.589 129.551H58.3814L46.7969 266.283Z"
          fill="#F0F0F0"
        />
        <path
          d="M46.7969 266.283H250.012L258.388 129.551H58.3814L46.7969 266.283Z"
          fill="#E0E0E0"
        />
        <path
          d="M46.7969 266.283H250.012L256.995 125.209H53.7874L46.7969 266.283Z"
          fill="#F0F0F0"
        />
        <path
          d="M46.7969 266.283H250.012L252.776 125.209H53.7874L46.7969 266.283Z"
          fill="#E0E0E0"
        />
        <path
          d="M46.7969 266.283H250.012L251.222 121.381H48.0066L46.7969 266.283Z"
          fill="#F0F0F0"
        />
        <path
          d="M46.7973 266.283H250.012L245.84 124.122H43.9414L46.7973 266.283Z"
          fill="#E0E0E0"
        />
        <path
          d="M46.7973 266.283H250.012L243.979 125.209H40.7715L46.7973 266.283Z"
          fill="#F0F0F0"
        />
        <path
          d="M46.7967 266.283H250.012L240.403 127.338H37.1953L46.7967 266.283Z"
          fill="#E0E0E0"
        />
        <path
          d="M46.7968 266.283H250.012L238.871 128.525H35.6641L46.7968 266.283Z"
          fill="#F0F0F0"
        />
        <path
          d="M148.561 138.088C148.691 134.267 151.57 131.557 155.49 131.557H216.782C221.429 131.557 225.939 135.324 226.843 139.979L251.053 263.986C251.964 268.633 248.924 272.408 244.277 272.408H49.7827C45.1351 272.408 40.6254 268.641 39.7219 263.986L19.761 161.77C18.8499 157.122 21.8895 153.347 26.5371 153.347H132.375C141.54 153.347 148.247 147.023 148.561 138.088Z"
          fill="#407BFF"
        />
        <path
          opacity="0.2"
          d="M148.561 138.088C148.691 134.267 151.57 131.557 155.49 131.557H216.782C221.429 131.557 225.939 135.324 226.843 139.979L251.053 263.986C251.964 268.633 248.924 272.408 244.277 272.408H49.7827C45.1351 272.408 40.6254 268.641 39.7219 263.986L19.761 161.77C18.8499 157.122 21.8895 153.347 26.5371 153.347H132.375C141.54 153.347 148.247 147.023 148.561 138.088Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_1769_21252">
          <rect width="338.24" height="281.068" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
export default PlacementNoData
